import React from 'react'

export default function Footer() {


    const footer = [
        {
            name: "JAMES STREET",
            links: [
                {
                    name: ' News',
                    link: 'https://www.jamesst.com.au/news'
                },
                {
                    name: ' Events',
                    link: 'https://www.jamesst.com.au/events'
                },
                {
                    name: ' About',
                    link: 'https://www.jamesst.com.au/about'
                },
                {
                    name: ' Contact',
                    link: 'https://www.jamesst.com.au/about'
                },
            ]
        },
        {
            name: "CATEGORIES",
            links: [
                {
                    name: ' Fashion',
                    link: 'https://www.jamesst.com.au/fashion'
                },
                {
                    name: ' Food & Drink',
                    link: 'https://www.jamesst.com.au/food-drink'
                },
                {
                    name: ' Health & Beauty',
                    link: 'https://www.jamesst.com.au/health-beauty'
                },
                {
                    name: ' Lifestyle & Design',
                    link: 'https://www.jamesst.com.au/lifestyle-design'
                },
            ]
        },
        {
            name: "Social",
            links: [
                {
                    name: ' Facebook',
                    link: 'https://www.facebook.com/jamesstbne'
                },
                {
                    name: ' Instagram',
                    link: 'https://instagram.com/jamesstbne'
                },
                {
                    name: ' Twitter',
                    link: 'https://twitter.com/jamesstbne'
                },
                {
                    name: ' Videos',
                    link: 'https://www.jamesst.com.au/videos'
                },
            ]
        },
        {
            name: "GIFT CARDS",
            links: [
                {
                    name: ' Purchase Gift Card',
                    link: 'https://www.jamesst.com.au/giftcard'
                },
                {
                    name: ' Check Gift Card Balance',
                    link: 'https://giftcards.indue.com.au/jamesst'
                },
                {
                    name: ' Gift Card Terms',
                    link: 'https://www.jamesst.com.au/gift-card-terms'
                },
            ]
        },
        {
            name: "LEGAL",
            links: [
                {
                    name: ' Privacy Policy',
                    link: 'https://www.jamesst.com.au/privacy-policy'
                },
                {
                    name: ' Terms & Conditions',
                    link: 'https://www.jamesst.com.au/terms-conditions'
                },
            ]
        },
        {
            name: "Enquiries",
            links: [
                {
                    name: ' Leasing',
                    link: 'mailto:leasing@jamesst.com.au'
                },
               
            ]
        }
    ]


    function scrollToTop () {
          window.scrollTo({top:0,left:0,behavior:'smooth'})
    }

    return (
        <div className='flex justify-center bg-white pt-[30px] pb-[30px]'>
            <div className='max-w-1200 pl-[15px] pr-[15px] w-full '>
            <div className='grid grid-cols-6 md:grid-cols-2'>
                {footer.map((section,index) => {
                    return (
                        <div key={index}> 
                            <h5 className='title'>{section.name}</h5>
                            {section.links.map((link,index) => {
                                return (
                                    <a  key={index} href={link.link} className='footer-link'>
                                       {link.name}
                                    </a>
                                )

                            })}
                        </div>
                    )
                })}

               
               
            </div>
            <div className='mt-[40px] flex justify-between'>
                    <p className='small'>©{new Date().getFullYear()} JAMES STREET INITIATIVE</p>
                    <button onClick={scrollToTop} className='small uppercase'>Back to Top</button>
                </div>
                </div>
        </div>

    )
}
